var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPassword3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2601",
    "data-name": "Groupe 2601",
    transform: "translate(-832 -286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2374",
    "data-name": "Groupe 2374",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 128,
    cy: 128,
    r: 128,
    transform: "translate(832 275)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2373",
    "data-name": "Groupe 2373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2910",
    "data-name": "Trac\\xE9 2910",
    d: "M3.883,156.739,21.9,141.8a.7.7,0,0,1,1.151.541v26a.7.7,0,0,1-1.07.6L3.964,157.878a.7.7,0,0,1-.081-1.14",
    transform: "translate(873.709 223.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2911",
    "data-name": "Trac\\xE9 2911",
    d: "M441.27,151.625l-21.293,12a.7.7,0,0,1-1.047-.612v-30.17a.7.7,0,0,1,1.159-.534l21.292,18.174a.7.7,0,0,1-.111,1.147",
    transform: "translate(601.058 229.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2912",
    "data-name": "Trac\\xE9 2912",
    d: "M186.384,14.674V79.307l-36.966,20.825H104.745L69.71,78.623V14.674A14.673,14.673,0,0,1,84.384,0h87.331a14.672,14.672,0,0,1,14.67,14.674",
    transform: "translate(830.326 316.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2913",
    "data-name": "Trac\\xE9 2913",
    d: "M172.023,65.323H126.954a4.874,4.874,0,0,1,0-9.748h45.069a4.874,4.874,0,1,1,0,9.748",
    transform: "translate(795.944 279.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2914",
    "data-name": "Trac\\xE9 2914",
    d: "M201.446,130.563H126.953a4.874,4.874,0,0,1,0-9.748h74.493a4.874,4.874,0,0,1,0,9.748",
    transform: "translate(795.945 236.744)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2915",
    "data-name": "Trac\\xE9 2915",
    d: "M1.069,200.221l53.613,32.733a.7.7,0,0,1,.1,1.126L1.168,281.521A.7.7,0,0,1,0,280.994V200.821a.7.7,0,0,1,1.069-.6",
    transform: "translate(876.092 184.682)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2916",
    "data-name": "Trac\\xE9 2916",
    d: "M112.642,300.98l59.053,48.208a.7.7,0,0,1-.444,1.247H12.963a.7.7,0,0,1-.466-1.229l54.29-48.036a.7.7,0,0,1,.465-.176h45.18a1.383,1.383,0,0,0,.206-.014Z",
    transform: "translate(868.044 118.463)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2917",
    "data-name": "Trac\\xE9 2917",
    d: "M374.819,200.307v80.017a.7.7,0,0,1-1.147.544l-58.108-47.433a.7.7,0,0,1,.1-1.157l58.108-32.584a.7.7,0,0,1,1.046.613",
    transform: "translate(669.089 185.019)",
    fill: "#e30613"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword3);
export default __webpack_public_path__ + "static/media/resetPassword3.e6af920a8eef8f3ff828ebfbdf123169.svg";
export { ForwardRef as ReactComponent };